import { TextBase, TextCaption, TooltipBubble } from '@carboncopyco/ui';
import { MMMDoYYYYhmma } from '@carboncopyco/utils';

export const TimestampCol = ({ timestamp }: { timestamp: string }) => {
  const parsedDatetime = MMMDoYYYYhmma(timestamp);
  const dateTimeParts = parsedDatetime.split('at');
  const date = dateTimeParts[0].trim();
  const time = dateTimeParts[1].trim();
  return (
    <div className="flex flex-col">
      <TooltipBubble
        title={parsedDatetime}
        placement="top-start"
      >
        <div className="truncate">
          <TextBase
            label={date}
            color="text-ds-natural-600"
            ellipsis
          />
        </div>
      </TooltipBubble>
      <TextCaption label={time} />
    </div>
  );
};
